import { Button } from "@icecreamsocial/components";
import React from "react";
import { useIntl } from "react-intl";

export const ConsentEditButton = ({ onClick }) => {
  const intl = useIntl();

  const EDIT_BUTTON = intl.formatMessage({
    id: "consent.button.edit",
    defaultMessage: "Edit",
    description:
      "Shows next to a consent checkbox.  Clicking it will take them to the page to edit either phone number or email"
  });

  return (
    <Button type="button" padding="sm" onClick={onClick}>
      {EDIT_BUTTON}
    </Button>
  );
};
